import db from "../db/database";
import { Company } from "../interfaces/company";

// Servicio para manejar las operaciones relacionadas con la empresa

// Obtener la información de la empresa (solo lectura)
export const getEmpresa = async () : Promise<Company> => {
    try {
        // Obtener la empresa desde la base de datos local
        const empresa = await (db as any).empresa.orderBy('id').first();

        if (!empresa) {
            throw new Error("Información de empresa no encontrada");
        }

        return empresa;
    } catch (error) {
        console.error("Error al obtener información de la empresa:", error);
        throw error;
    }
};

// Verificar si existe información de empresa
export const hasEmpresaData = async () : Promise<boolean> => {
    try {
        const count = await (db as any).empresa.count();
        return count > 0;
    } catch (error) {
        console.error("Error al verificar información de empresa:", error);
        return false;
    }
};

// Obtener campo específico de la empresa
export const getEmpresaField = async (fieldName:string) => {
    try {
        const empresa = await getEmpresa();
        return empresa[fieldName as keyof Company] || null;
    } catch (error) {
        console.error(`Error al obtener campo ${fieldName} de la empresa:`, error);
        return null;
    }
};

// Obtener información básica de la empresa (campos más comunes)
export const getEmpresaBasicInfo = async () => {
    try {
        const empresa = await getEmpresa();

        return {
            nombre: empresa.Name,
            direccion: empresa.Address,
            direccion2: empresa.Address_2,
            ciudad: empresa.City,
            provincia: empresa.County,
            codigoPostal: empresa.Post_Code,
            pais: empresa.Country_Region_Code,
            telefono: empresa.Phone_No,
            telefono2: empresa.Phone_No_2,
            fax: empresa.Fax_No,
            email: empresa.E_Mail,
            web: empresa.Home_Page,
            ruc: empresa.VAT_Registration_No,
            contribuyenteEspecial: empresa.Cod_contribuyente_especial,
            codigoDinardap: empresa.Código_otorgado_por_DINARDAP,
            facturaElectronica: empresa.Auto_E_Invoice
        };
    } catch (error) {
        console.error("Error al obtener información básica de la empresa:", error);
        throw error;
    }
}; 